import { createAPI } from '@/request.js'
// 商家钱包
export const rule = data => createAPI('/api/withdraw/rule/query.mt', 'post', data)
// 提现记录
export const list = data => createAPI('/api/withdraw/query.mt', 'post', data)
// 处理提现
export const withdraw = data => createAPI('/api/withdraw/state/modify.mt', 'post', data)
// 处理提现
export const setRule = data => createAPI('/api/withdraw/rule/set.mt', 'post', data)
// 导出提现
export const excel = data => createAPI('/download/withdraw/excel', 'get', data)
